import React from "react";
import BrandedResetPassword from "@/pages/branded/BrandedResetPassword";

const BRAND = {
  name: "Management USA NJ",
  tagline: "Admin portal",
  apiPrefix: "/mgmt",
  loginPath: "/managementusa",
};

export default function MgmtResetPassword() {
  return <BrandedResetPassword brand={BRAND} testidPrefix="mgmt-reset" />;
}
